import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterSelectInputBoxHandler from "./IDataFilterSelectInputBoxHandler";
import IDataFilterSelectInputValue from "./IDataFilterSelectInputValue";

export default class DataFilterSelectInputBoxHandler
  implements IDataFilterSelectInputBoxHandler {
  setDescriptorValuesFromUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    (descriptor.value as IDataFilterSelectInputValue).value =
      urlParams.get(descriptor.name) ?? "";
  }

  setDescriptorValuesToUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    const htmlSelectValue = descriptor.value as IDataFilterSelectInputValue;
    if (htmlSelectValue.value) {
      urlParams.set(descriptor.name, htmlSelectValue.value);
    } else {
      urlParams.delete(descriptor.name);
    }
  }
}
